import { render } from "./ylyPTseletctPromotion.vue?vue&type=template&id=db589236&scoped=true"
import script from "./ylyPTseletctPromotion.vue?vue&type=script&lang=js"
export * from "./ylyPTseletctPromotion.vue?vue&type=script&lang=js"

import "./ylyPTseletctPromotion.vue?vue&type=style&index=0&id=db589236&lang=scss&scoped=true"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db589236"]])

export default __exports__